(function () {
  'use strict';

  var embedPromise;
  var embedUrl = 'https://js.hsforms.net/forms/embed/v2.js';

  function hubspotForms() {
    return window.hbspt && window.hbspt.forms && typeof window.hbspt.forms.create === 'function'
      ? window.hbspt.forms
      : null;
  }

  function loadEmbed() {
    if (hubspotForms()) return Promise.resolve(hubspotForms());
    if (embedPromise) return embedPromise;

    embedPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = embedUrl;
      script.async = true;
      script.onload = function () {
        var forms = hubspotForms();
        if (forms) {
          resolve(forms);
        } else {
          script.remove();
          reject(new Error('HubSpot forms API is unavailable'));
        }
      };
      script.onerror = function () {
        script.remove();
        reject(new Error('HubSpot forms script failed to load'));
      };
      document.head.appendChild(script);
    }).catch(function (error) {
      embedPromise = null;
      throw error;
    });

    return embedPromise;
  }

  function showStatus(container, message, canRetry) {
    var status = container.querySelector('[data-hubspot-status]');
    var retry = container.querySelector('[data-hubspot-retry]');
    if (status) {
      status.textContent = message;
      status.hidden = !message;
    }
    if (retry) retry.hidden = !canRetry;
  }

  function loadForm(container) {
    if (!container || container.dataset.hubspotState === 'loading' || container.dataset.hubspotState === 'ready') return;

    var target = container.querySelector('[data-hubspot-target]');
    if (!target || !target.id || !container.dataset.hubspotFormId || !container.dataset.hubspotPortalId) return;

    target.textContent = '';
    container.dataset.hubspotState = 'loading';
    showStatus(container, 'Loading form…', false);

    var slowTimer = window.setTimeout(function () {
      if (container.dataset.hubspotState === 'loading') {
        showStatus(container, 'The form is taking longer than expected. Please refresh if it does not appear.', false);
      }
    }, 15000);

    loadEmbed().then(function (forms) {
      forms.create({
        region: container.dataset.hubspotRegion,
        portalId: container.dataset.hubspotPortalId,
        formId: container.dataset.hubspotFormId,
        target: '#' + target.id,
        onFormReady: function () {
          window.clearTimeout(slowTimer);
          container.dataset.hubspotState = 'ready';
          showStatus(container, '', false);
        }
      });
    }).catch(function () {
      window.clearTimeout(slowTimer);
      container.dataset.hubspotState = 'error';
      showStatus(container, 'The form could not load. Please try again.', true);
    });
  }

  document.querySelectorAll('[data-deferred-hubspot-form]').forEach(function (container) {
    var retry = container.querySelector('[data-hubspot-retry]');
    if (retry) retry.addEventListener('click', function () { loadForm(container); });
  });

  var popup = document.querySelector('[data-deferred-hubspot-popup]');
  if (popup) {
    var quickQuote = popup.querySelector('[data-deferred-hubspot-form="quick-quote"]');
    var loadWhenOpen = function () {
      if (popup.classList.contains('show') || popup.style.display === 'block') loadForm(quickQuote);
    };

    new MutationObserver(loadWhenOpen).observe(popup, { attributes: true, attributeFilter: ['class', 'style'] });
    window.addEventListener('load', loadWhenOpen, { once: true });

    var headerTrigger = document.querySelector('.header__icons #customPackagingTrigger');
    if (headerTrigger) {
      headerTrigger.addEventListener('pointerenter', function () { loadForm(quickQuote); }, { once: true });
      headerTrigger.addEventListener('focusin', function () { loadForm(quickQuote); }, { once: true });
    }
  }

  var contact = document.querySelector('[data-deferred-hubspot-form="homepage-contact"]');
  if (contact) {
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      loadForm(contact);
    } else {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          observer.disconnect();
          loadForm(contact);
        }
      }, { rootMargin: '800px 0px' });
      observer.observe(contact);
    }
  }
})();
